import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "9",
  viewBox: "0 0 14 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7 7.35714L9.03571 4.625",
      stroke: "#344054",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13 7.94559C13 3.82059 10.4821 1.30273 7 1.30273C4.10714 1.30273 1 3.23131 1 7.94559",
      stroke: "#344054",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }